import React from 'react';
import logo from './logo.jpg';
import Accordion from 'react-bootstrap/Accordion';
import PropTypes from "prop-types";
import Badge from 'react-bootstrap/Badge';
function Home() {
    const YoutubeEmbed = ({ embedId }) => (
        <div className="video-responsive">
          <iframe
            width="853"
            height="480"
            src={`https://www.youtube.com/embed/${embedId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      );
      
      YoutubeEmbed.propTypes = {
        embedId: PropTypes.string.isRequired
      };

    return ( <div className = "App" >

        <header className = "App-header" >
        <img src = { logo }
        className = "App-logo"
        alt = "logo" />

        <a className = "App-link"
        href = "https://www.facebook.com/techlearnland"
        target = "_blank"
        rel = "noopener noreferrer" >
        Tech Learn Land </a>

        </header> <p className = "alert alert-success" >
        สอนเขียนโปรแกรม สอนออนไลน์ สอนสด ตั วต่ อตั ว ผ่ านการรีโมทหน้ าจอ สอนตั้ งแต่ ประถม ถึงวั ยทำงาน </p>

        <p className = 'alert alert-danger' >
        <Badge bg="primary">Python</Badge>
        <Badge bg="secondary">Javascript</Badge>
        <Badge bg="success">TypeScript</Badge>
        <Badge bg="secondary">Java</Badge>
        <Badge bg="warning">C#</Badge>
        <Badge bg="success">React</Badge>
        <Badge bg="secondary">Node.js</Badge>
        <Badge bg="primary">Node.js</Badge>
         
         <Badge bg="success"> SQL command, MySQL, Mongo, Firebase</Badge>
        </p> 
        <p>
        และอื่น ๆ ที่ ผู้ เรียนต้ องการให้ สอนเพิ่ มเติม ที่ ไม่ อยู่ ในรายการ </p> 
        <a className = "App-link"
        href = "https://www.facebook.com/techlearnland"
        target = "_blank"
        rel = "noopener noreferrer" >
        สนใจเรียนเขียนโปรแกรม คลิกที่ นี่ </a> 
        <div className="container">
            <h3>เขียน Python ทำเกมทายตัวเลข ด้วย random และ while </h3>
            <YoutubeEmbed embedId="EK0etZHsPAc?si=koiiqxFc3ttU1yjD" />

            <h3>Java Socket </h3>
            <YoutubeEmbed embedId="dOT5Z-OaT1c?si=7m8bJEy8Rz5Jbp0I" />
        </div>
       </div >
    );
}

export default Home;